import { createContext } from "react";
import type { AppContainer } from "./AppContainer";

export const DIContext = createContext<AppContainer | null>(null);
